export default __webpack_public_path__ + "static/media/ceo1.76a62168.jpg";